module.exports = __webpack_public_path__ + "img/7-1s.41a72173.jpg";